import React from 'react';
import cn from 'classnames';
import ReactDatePicker from 'react-datepicker';
import { prettyKey } from 'helpers/formatters';

import styles from '../forms.module.css';
import ownStyles from './index.module.css';

export default ({
  input,
  input: { name, onChange },
  meta: { touched, error },
  label,
  placeholder,
  required,
  ...props
}) => (
  <div className={cn({
    [styles.InputField]: true,
    [ownStyles.wrapper]: true,
    'has-error': touched && error,
    'has-success': touched && !error
  })}>
    <label className={styles.inputLabel}>
      {label ? label : prettyKey(name)}
      {required && <span className={styles.asterisk}>*</span>}
    </label>
    <ReactDatePicker 
      className={ownStyles.picker}
      selected={input.value}
      name={name}
      onChange={onChange}
      {...props}
    />
    {
      touched && error &&
      <span className="help-block">
        {error}  
      </span>
    }
  </div>
);

